import React from 'react'
import ReactDOMClient from 'react-dom/client'
import singleSpaReact from 'single-spa-react'
import './styles.scss' // Import your styles

import { Root } from 'app/Root'

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  // errorBoundary() {
  //   //Add your error boundary here
  //   return <></>
  // },
  errorBoundary(err) {
    console.error('BVA Root render error:', err)
    return <></>
  },
})

// Re-attach the Tailwind/global style tag if the host removed it between
// activations, since single-spa's mount/unmount never re-run `import './styles.scss'`.
const reattachStyles = () => {
  try {
    const styleTags = (window as unknown as { __mosPgBvaStyleTags?: HTMLStyleElement[] }).__mosPgBvaStyleTags
    styleTags?.forEach(styleTag => {
      if (!styleTag.isConnected) {
        document.head.appendChild(styleTag)
      }
    })
  } catch (err) {
    console.error('reattachStyles failed:', err)
  }
  return Promise.resolve()
}
export const bootstrap = lifecycles.bootstrap
export const mount = [reattachStyles, lifecycles.mount]
export const unmount = lifecycles.unmount
